import React, { useContext } from "react";
import "./style.css"; // Import the CSS file for styling
import Logo from "../../../images/logo/chinook_blue-logo-only.png";
import LogoWhite from "../../../images/logo/logo-white.png";
// import cwt from "../../../images/cwt.png";
// import chinook_cb from "../../../images/chinook_cb.png";
import { AuthContext } from "../../../context/authContext";
import { useNavigate, useLocation } from "react-router-dom";
import { userNavItems } from "../navItems";
import { isNavHrefActive } from "../navLinkActive";
import { hasModuleAccess, hasAnyModuleAccess, isAdminUser } from "../../../constants/appModules";
import UserAvatar from "../UserAvatar";
import ThemeToggle from "../../ThemeToggle";
import { StyleContext } from "../../../context/styleContext";

function HorizontalNavbar() {
  const { user, allowedModules, logout } = useContext(AuthContext);
  const { colorMode } = useContext(StyleContext);
  const isDark = colorMode === "dark";
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const logoutAndRedirect = () => {
    logout();
  };

  const redirectToLogin = () => {
    navigate("/login");
  };

  return (
    <nav>
      <div className="wrapper">
        <div className="logo">
          <a href="/">
            <img
              alt="logo"
              src={isDark ? LogoWhite : Logo}
              style={{
                marginTop: isDark ? "15px" : undefined,
                paddingTop: isDark ? undefined : "15px",
                width: "120px",
                height: isDark ? "58px" : "40px",
              }}
            />
          </a>
        </div>
        <input type="checkbox" id="menu-btn" />
        <input type="checkbox" id="close-btn" />
        <ul className="nav-links">
          <label htmlFor="close-btn" className="btn close-btn">
            <i className="fas fa-times"></i>
          </label>
          {/*NEWWW  */}
          {user?.id ? (
            <>
              {userNavItems
                .filter((item) => {
                  if (isAdminUser(user)) return true;

                  const role = user?.role?.toLowerCase();
                  if (item.adminOnly && role !== "admin" && role !== "owner") {
                    return false;
                  }
                  if (
                    item.modulesAny?.length &&
                    !hasAnyModuleAccess(allowedModules, item.modulesAny)
                  ) {
                    return false;
                  }
                  if (item.module && !hasModuleAccess(allowedModules, item.module)) {
                    return false;
                  }
                  return true;
                })
                .map((item) => {
                // Direct Links
                return item.type === "link" ? (
                  <li key={item.label}>
                    <a
                      href={item.link}
                      className={
                        isNavHrefActive(pathname, item.link)
                          ? "nav-link-active"
                          : undefined
                      }
                    >
                      {item.label}
                    </a>
                  </li>
                ) : item.type === "mega_menu" ? (
                  <li key={item.label}>
                    <a href="#" className="desktop-item">
                      {item.label}
                      <i
                        className="fas fa-chevron-down"
                        style={{ marginLeft: "5px" }}
                      ></i>
                    </a>
                    <input type="checkbox" id="showMega" />
                    <label htmlFor="showMega" className="mobile-item">
                      {item.label}
                    </label>
                    <div className="mega-box">
                      <div className="content">
                        {item.items.map((subItem) => (
                          <div className="row" key={subItem.header}>
                            <header>{subItem.header}</header>
                            <ul className="mega-links">
                              {subItem.subItems.map((subItem) => (
                                <li key={subItem.label}>
                                  <a href={subItem.link}>{subItem.label}</a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>
                    </div>
                  </li>
                ) : null;
              })}
              <li></li>
              <li style={{ display: "flex", alignItems: "center" }}>
                <ThemeToggle />
                <UserAvatar />
              </li>
            </>
          ) : (
            <>
              <li>
                <ThemeToggle />
              </li>
              <li>
                <a style={{ cursor: "pointer" }} onClick={redirectToLogin}>
                  Login
                </a>
              </li>
            </>
          )}
        </ul>
        <label htmlFor="menu-btn" className="btn menu-btn">
          <i className="fas fa-bars"></i>
        </label>
      </div>
    </nav>
  );
}

export default HorizontalNavbar;
